import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types';
import Dialog from 'components/Dialog';
import {makeStyles} from "@material-ui/styles";
import GridBlock from "components/GridBlock";
import PollService from "services/PollService";
import BoldTypography from "components/BoldTypography";
import PollNpsSwitch from "./PollNpsSwitch";

const useStyle = makeStyles(theme => ({
    button: {
        padding: "20px 25px"
    },
    question: {
        marginBottom: theme.spacing()
    }
}))



function Poll(
    {
        demandId,
        pollType,
        onClose
    }) {
    const classes = useStyle();

    const [poll, setPoll] = useState({});

    useEffect(() => {
        PollService.getPoll(pollType).then((resp) => setPoll(resp));
        // eslint-disable-next-line
    }, [])


    const handleChange = (event, rate) => {

        const rating = {
            pollType: pollType,
            objectType: "demand",
            objectId: demandId,
            score: rate
        }
        PollService.savePollRating(rating);
        onClose();

    };

    return (
        <Dialog
            title={poll.title}
            open={Boolean(poll && poll.enabled)}
            titleCentered
            maxWidth='md'
            onClose={onClose}

        >
            <GridBlock justify='center'>
                <BoldTypography className={classes.question}>{poll.question}</BoldTypography>

                <PollNpsSwitch scoreChange={handleChange} classes={{button: classes.button}} />
            </GridBlock>
        </Dialog>
    )
}

Poll.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    pollType: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired
}

export default Poll;